module.exports = __webpack_public_path__ + "img/bg.44bb8584.jpg";